const entityMap = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&#39;',
	'/': '&#x2F;',
	'`': '&#x60;',
	'=': '&#x3D;'
};

export function escapeHtml(string) {
	return String(string).replace(/[&<>"'`=\/]/g, function(s) {
		return entityMap[s];
	});
}

export const randomString = function(length) {
	const chars =
		'0123456789' + 'ABCDEFGHIJKLMNOPQRSTUVWXTZ' + 'abcdefghiklmnopqrstuvwxyz';

	let random = '';
	for (let i = 0; i < length; i++) {
		let rnum = Math.floor(Math.random() * chars.length);
		random += chars.substring(rnum, rnum + 1);
	}

	return random;
};

export const smartRound = (val) => {
	if (val < 1) {
		return 1;
	}

	const logValue = Math.floor(Math.log10(val));
	return Math.pow(10, logValue);
};

export const destroyBackboneView = (view) => {
	if (view) {
		view.undelegateEvents();
		$(view.el)
			.removeData()
			.unbind();
	}
};

export const makeStringFileSafe = (str) => {
	return str.replace(/[^a-z0-9]/gi, '_').toLowerCase();
};

export function readFromFile(file) {
	return new Promise((resolve) => {
		const reader = new FileReader();

		reader.addEventListener(
			'load',
			function() {
				resolve(reader.result);
			},
			false
		);

		reader.readAsDataURL(file);
	});
}

export function decimalPlaces(num) {
	const match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
	if (!match) {
		return 0;
	}
	return Math.max(
		0,
		// Number of digits right of decimal point.
		(match[1] ? match[1].length : 0) -
			// Adjust for scientific notation.
			(match[2] ? +match[2] : 0)
	);
}

export function round(value, decimals) {
	return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

export const spectrumDefaults = {
	showAlpha: false,
	allowAlpha: false,
	showPalette: true,
	showButtons: true,
	allowEmpty: true,
	showInitial: true,
	showInput: true,
	preferredFormat: 'hex',
	palette: [
		[
			'#333e48',
			'#7c878e',
			'#9DA5AA',
			'#d0d2d3',
			'#e1e4e6',
			'#efefef',
			'#f7f8f8',
			'#ffffff'
		],
		['#05467e', '#00bf6f', '#f9be00', '#F05B24', '#1F8FB0', '#E0F1FF'],
		['#125A98', '#318DBC', '#51B3D0', '#7ECCC3', '#A9DCB6']
	]
};

//natural sort i.e. [1, 4, 10]
export const natSort = (list) => {
	list.sort(
		new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
			.compare
	);
};



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.common/utils.js